import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, WalletIcon } from 'lucide-react';
export function TrustRow() {
  const items = [{
    icon: LockIcon,
    label: 'Pago seguro'
  }, {
    icon: ZapIcon,
    label: 'Acceso en 5 min'
  }, {
    icon: ShieldCheckIcon,
    label: 'Garantía 7 días'
  }, {
    icon: WalletIcon,
    label: 'Mercado Pago'
  }];
  return <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-mist" data-id="element-287" data-mp="2cq675bvi5lwu">
      {items.map(({
      icon: Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-288" data-mp="1k18qfd6xvx67">
          <Icon className="h-4 w-4 text-pumpkin-soft" aria-hidden="true" data-id="element-289" data-mp="1yxztpxjqht13" />
          {label}
        </li>)}
    </ul>;
}